export enum ToasterEvents {
  ClosedByClick = 'ClosedByClick',
  ClosedByTimeout = 'ClosedByTimeout',
}
